export const TcFF = {
  tcAllowDependents: 'tcAllowDependents',
  tcPsychScheduling30DayLimit: 'tcPsychScheduling30DayLimit',
  tcMinorConsentPhase2: 'tcMinorConsentPhase2',
  tcStudentSuccessContent: 'tcStudentSuccessContent',
  tcSuccessEntryTerminology: 'tcSuccessEntryTerminology',
  tcServiceLineRouting: 'tcServiceLineRouting',
  tcAddToCalendar: 'tcAddToCalendar',
  tcLocalization: 'tcLocalization',
  tcPhoneOptIn: 'tcPhoneOptIn',
  tcDisabledConfirm: 'tcDisabledConfirm',
  tcSuccessCoachingNowRemove: 'tcSuccessCoachingNowRemove',
  tcProviderLowRatingFeedback: 'tcProviderLowRatingFeedback',
  tcHomeScreen: 'tcHomeScreen',
  tcContentPlayground: 'tcContentPlayground',
  tcCmsV2: 'tcCmsV2',
  tcBreath: 'tcBreath',
  tcVisitRescheduling: 'tcVisitRescheduling',
  tcMemberProfile: 'tcMemberProfile',
  tcPrevisitConsentRegulations: 'tcPrevisitConsentRegulations',
  afterHoursV2: 'afterHoursV2',
  tcSoundscapes: 'tcSoundscapes',
  tcStreakTracking: 'tcStreakTracking',
} as const
